import React from "react"
import Layout from "components/Layout"
import styled from "@emotion/styled"

const ContactTitle = styled("h1")`
  margin-bottom: 1em;
`

export default () => {
  return (
    <Layout>
      <ContactTitle>Contact</ContactTitle>
      <p>
        <b>Questions and feedback</b>
        <br />
        For any questions and feedback contact us at <a href="mailto:contact@moderndev.tech">contact@moderndev.tech</a>.
      </p>
      <p>
        <b>Bulk and education discounts available</b>
        <br />
        Interested in a classroom or workshop pack? Email 
        <a href="mailto:contact@moderndev.tech">contact@moderndev.tech</a> and we'll get back to you.
      </p>
    </Layout>
  )
}
